// extracted by mini-css-extract-plugin
export default {"remainingCredit":"Cart_remainingCredit__hHPVu","itemsContainer":"Cart_itemsContainer__xScy7"};